<script>
    export let classname = ''
</script>
<style>
    section {
        height: 100%;
    }

    .stripe {
        height: 100%;
        display: flex;
        flex-direction: row;
        padding: 4em;
    
    	box-sizing: border-box;
    	width: var(--site-width);
	    margin-left: auto;
        margin-right: auto;
    }

    .secondary .stripe {
        flex-direction: row-reverse;
    }

    .stripe > div {
        flex: 1;
        height: 100%;
    }

    .stripe .left {
        padding: 1em;
        height: 100%;
    }

    .stripe .right {
        text-align: center;
        height: 100%;
        margin: 1em 3em;
    }
</style>
<section class={classname}>
    <div class="stripe">        
        <div class="left">
            <slot name="left"/>
        </div>
        <div class="centered right">
            <slot name="right"/>
        </div>
    </div>
</section>